module.exports = __webpack_public_path__ + "img/39.b1b715d9.jpg";